/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { RestoreMethodAvailabilityReason } from '../models/RestoreMethodAvailabilityReason';

export class DynamoDBRestoreMethodAvailabilityResponse {
  /**
  * Whether the restore method is available for the snapshot.
  */
  'available': boolean;
  /**
  * List of reasons why the restore method is not available. Only present when available is false.
  */
  'reasons'?: Array<RestoreMethodAvailabilityReason>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "available",
      "baseName": "available",
      "type": "boolean",
      "format": ""
    },
    {
      "name": "reasons",
      "baseName": "reasons",
      "type": "Array<RestoreMethodAvailabilityReason>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return DynamoDBRestoreMethodAvailabilityResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

